module.exports = __webpack_public_path__ + "static/media/lead_m.4fa802cd.png";